import { GetInternalAccountsResponse } from "@/app/api/internal-accounts/route";
import { getInternalAccountsRequestSchema } from "@/lib/schemas/internal-accounts";
import { createInvalidateQuery, createQueryHook } from "@/lib/queries";

const INTERNAL_ACCOUNTS_ENDPOINT = "/api/internal-accounts";

export const invalidateInternalAccountsQuery = createInvalidateQuery(
  INTERNAL_ACCOUNTS_ENDPOINT,
);

export const useInternalAccountsQuery =
  createQueryHook<GetInternalAccountsResponse>(
    INTERNAL_ACCOUNTS_ENDPOINT,
    getInternalAccountsRequestSchema,
  );
